import React from 'react';

import AuthWrapper from '../../features/login/AuthWrapper';

import './Banner.scss';

const Banner = () => {
  return (
    <div className='banner-desk'>
      <div className='banner'>
        <div className='grow_offer'>
          <span>
            Tăng thu nhập cùng <span style={{ color: '#FF3366' }}> Mytour</span>
          </span>

          <span>Tích lũy Hoa hồng ngay hôm nay!</span>
          <span className='description'>
            Sản phẩm của chúng tôi mang đến mức giá cạnh tranh, đảm bảo tỷ lệ
            chuyển đổi cao và đem về cho bạn các khoản hoa hồng hấp dẫn.
          </span>
          <AuthWrapper typeModal='REGISTER_MODAL'>
            <div className='register'>
              <span> Đăng ký tham gia</span>
            </div>
          </AuthWrapper>
        </div>
      </div>
    </div>
  );
};

export default Banner;
